'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; // Taken and adapted from https://gist.github.com/Bazze/81cf778d8843948977421bea5c8cdfee

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Input, _Component);

  function Input() {
    (0, _classCallCheck3.default)(this, Input);
    return (0, _possibleConstructorReturn3.default)(this, (Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).apply(this, arguments));
  }

  (0, _createClass3.default)(Input, [{
    key: 'getValue',
    value: function getValue() {
      var inputNode = (0, _reactDom.findDOMNode)(this.refs.formControl);

      if (this.props.type === 'select' && inputNode.multiple) {
        return this.getMultipleSelectValues(inputNode);
      }

      return inputNode.value;
    }
  }, {
    key: 'getMultipleSelectValues',
    value: function getMultipleSelectValues(selectNode) {
      var values = [];
      var options = selectNode.options;

      for (var idx = 0; idx < options.length; idx++) {
        var opt = options[idx];

        if (opt.selected) {
          values.push(opt.value || opt.text);
        }
      }

      return values;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          groupClassName = _props.groupClassName,
          labelClassName = _props.labelClassName,
          label = _props.label,
          help = _props.help,
          children = _props.children,
          props = (0, _objectWithoutProperties3.default)(_props, ['id', 'groupClassName', 'labelClassName', 'label', 'help', 'children']);


      if (props.type === 'select' || props.type === 'textarea') {
        props.componentClass = props.type;
        delete props.type;
      }

      return _react2.default.createElement(
        _reactBootstrap.FormGroup,
        { controlId: id, className: groupClassName },
        label && _react2.default.createElement(
          _reactBootstrap.ControlLabel,
          { className: labelClassName },
          label
        ),
        _react2.default.createElement(
          _reactBootstrap.FormControl,
          (0, _extends3.default)({ ref: 'formControl' }, props),
          children
        ),
        help && _react2.default.createElement(
          _reactBootstrap.HelpBlock,
          null,
          help
        )
      );
    }
  }]);
  return Input;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.any,
  groupClassName: _propTypes2.default.string,
  help: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  id: _propTypes2.default.string,
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  labelClassName: _propTypes2.default.string,
  type: _propTypes2.default.string.isRequired
}, _temp);
exports.default = Input;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/Input.js
// module id = 2215
// module chunks = 0